export enum JobStatus {
  Complete = 'Complete',
  Error = 'Error',
  InProgress = 'InProgress',
  Queued = 'Queued',
}
